module.exports = __webpack_public_path__ + "static/media/Motion.5c52be6c.logo";